function _typeof(obj) {
    '@babel/helpers - typeof';
    if (typeof Symbol === 'function' && typeof Symbol.iterator === 'symbol') {
        _typeof = function _typeof(obj) {
            return typeof obj;
        };
    } else {
        _typeof = function _typeof(obj) {
            return obj && typeof Symbol === 'function' && obj.constructor === Symbol && obj !== Symbol.prototype ? 'symbol' : typeof obj;
        };
    }
    return _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function () {
        var self = this, args = arguments;
        return new Promise(function (resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'next', value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, 'throw', err);
            }
            _next(undefined);
        });
    };
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
}
function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === '[object Arguments]')) {
        return;
    }
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);
            if (i && _arr.length === i)
                break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally {
        try {
            if (!_n && _i['return'] != null)
                _i['return']();
        } finally {
            if (_d)
                throw _e;
        }
    }
    return _arr;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr))
        return arr;
}
function _templateObject() {
    var data = _taggedTemplateLiteral(['Using the tech directly can be dangerous. I hope you know what you\'re doing.']);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } }));
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError('Cannot call a class as a function');
    }
}
function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ('value' in descriptor)
            descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
        _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
        _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === 'object' || typeof call === 'function')) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
    }
    return self;
}
function _get(target, property, receiver) {
    if (typeof Reflect !== 'undefined' && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base)
                return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target, property, receiver || target);
}
function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
        object = _getPrototypeOf(object);
        if (object === null)
            break;
    }
    return object;
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) {
        throw new TypeError('Super expression must either be null or a function');
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass)
        _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
import Component from './component.js';
import { version } from '../../package.json';
import document from 'global/document';
import window from 'global/window';
import tsml from 'tsml';
import evented, {
    isEvented,
    addEventedCallback
} from './mixins/evented';
import * as Events from '@emav-util/events.js';
import * as Dom from '@emav-util/dom.js';
import * as Fn from '@emav-util/fn.js';
import * as Guid from '@emav-util/guid.js';
import * as browser from '@emav-util/browser.js';
import log, { createLogger } from '@emav-util/log.js';
import toTitleCase, { titleCaseEquals } from '@emav-util/to-title-case.js';
import { createTimeRange } from '@emav-util/time-ranges.js';
import { bufferedPercent as _bufferedPercent } from '@emav-util/buffer.js';
import * as stylesheet from '@emav-util/stylesheet.js';
import FullscreenApi, { prefixedAPI as prefixedFS } from './fullscreen-api.js';
import MediaError from './media-error.js';
import safeParseTuple from 'safe-json-parse/tuple';
import { assign } from '@emav-util/obj';
import mergeOptions from '@emav-util/merge-options.js';
import { silencePromise } from '@emav-util/promise';
import Tech from './tech/tech.js';
import { ALL as TRACK_TYPES } from './tracks/track-types';
import filterSource from '@emav-util/filter-source';
import {
    getMimetype,
    findMimetype
} from '@emav-util/mimetypes';
import keycode from 'keycode';
import './tech/loader.js';
import AVBizWrapper from './biz/av-biz-wrapper';
import BizWarn from './biz/av-biz-warn';
var TECH_EVENTS_RETRIGGER = [
    'progress',
    'abort',
    'suspend',
    'emptied',
    'stalled',
    'loadedmetadata',
    'loadeddata',
    'timeupdate',
    'resize',
    'volumechange',
    'texttrackchange'
];
var TECH_EVENTS_QUEUE = {};
var Player = function (_Component) {
    _inherits(Player, _Component);
    function Player(tag, options, ready) {
        var _this;
        _classCallCheck(this, Player);
        tag.id = tag.id || options.id || 'emav_video_'.concat(Guid.newGUID());
        options = assign(Player.getTagSettings(tag), options);
        options.initChildren = false;
        options.createEl = false;
        options.evented = false;
        options.reportTouchActivity = false;
        if (!options.language) {
            if (typeof tag.closest === 'function') {
                var closest = tag.closest('[lang]');
                if (closest && closest.getAttribute) {
                    options.language = closest.getAttribute('lang');
                }
            } else {
                var element = tag;
                while (element && element.nodeType === 1) {
                    if (Dom.getAttributes(element).hasOwnProperty('lang')) {
                        options.language = element.getAttribute('lang');
                        break;
                    }
                    element = element.parentNode;
                }
            }
        }
        _this = _possibleConstructorReturn(this, _getPrototypeOf(Player).call(this, null, options, ready));
        _this.el_ = tag;
        console.log('emav - player >>>>>>>>>> : ', tag, options, _assertThisInitialized(_this), _this.options_, _this.options_.flash);
        _this.log = createLogger(_this.id_);
        _this.isPosterFromTech_ = false;
        _this.queuedCallbacks_ = [];
        _this.isReady_ = false;
        _this.hasStarted_ = false;
        if (!_this.options_ || !_this.options_.techOrder || !_this.options_.techOrder.length) {
            throw new Error('No techOrder specified. Did you overwrite ' + 'emav.options instead of just changing the ' + 'properties you want to override?');
        }
        _this.tag = tag;
        _this.standardFullscreenApi = typeof options.standardFullscreenApi !== 'undefined' ? options.standardFullscreenApi : true;
        _this.sysInfo = {
            FullscreenApi: FullscreenApi,
            prefixedAPI: prefixedFS,
            browser: browser
        };
        _this.tagAttributes = tag && Dom.getAttributes(tag);
        _this.resetCache_();
        tag.controls = false;
        tag.removeAttribute('controls');
        if (tag.hasAttribute('autoplay')) {
            _this.options_.autoplay = true;
        } else {
            _this.autoplay(_this.options_.autoplay);
        }
        evented(_assertThisInitialized(_this), { eventBusKey: 'el_' });
        var playerOptionsCopy = mergeOptions(_this.options_);
        _this.options_.playerOptions = playerOptionsCopy;
        _this.isAudio(tag.nodeName.toLowerCase() === 'audio');
        Player.players[_this.id_] = _assertThisInitialized(_this);
        var versions = version.split('.');
        _this.addClass('emav-v-'.concat(versions[0], '-').concat(versions[1], '-').concat(versions[2]));
        _this.changingSrc_ = false;
        _this.playWaitingForReady_ = false;
        _this.playOnLoadstart_ = null;
        var bizWrapper = _this.bizWrapper = new AVBizWrapper(_assertThisInitialized(_this), {
            env: !_this.options_.env ? 'production' : _this.options_.env,
            statistic: _this.options_.statistic,
            currentTime: _this.currentTime.bind(_assertThisInitialized(_this)),
            bizWarn: _this.warn.bind(_assertThisInitialized(_this))
        });
        _this.on('play', bizWrapper.onPlay.bind(bizWrapper));
        _this.on('firstplay', bizWrapper.onFirstPlay.bind(bizWrapper));
        _this.on('pause', bizWrapper.onPause.bind(bizWrapper));
        _this.on('seeking', bizWrapper.onSeeking.bind(bizWrapper));
        _this.on('seeked', bizWrapper.onSeeked.bind(bizWrapper));
        _this.on('ended', bizWrapper.onEnded.bind(bizWrapper));
        console.log('emav - player : <<<<<< ', _assertThisInitialized(_this), _this.options_, _this.options_.flash, '--');
        return _this;
    }
    _createClass(Player, [
        {
            key: 'warn',
            value: function warn(w) {
                if (w === undefined) {
                    return this.warn_ || null;
                }
                this.warn_ = new BizWarn(w);
                log.warn('(CODE:'.concat(this.warn_.code, ' ').concat(BizWarn.warnTypes[this.warn_.code], ')'), this.warn_.message, this.warn_);
                this.trigger('warn');
                return;
            }
        },
        {
            key: 'dispose',
            value: function dispose() {
                this.trigger('dispose');
                this.off('dispose');
                if (this.styleEl_ && this.styleEl_.parentNode) {
                    this.styleEl_.parentNode.removeChild(this.styleEl_);
                    this.styleEl_ = null;
                }
                Player.players[this.id_] = null;
                if (this.tag && this.tag.player) {
                    this.tag.player = null;
                }
                if (this.el_ && this.el_.player) {
                    this.el_.player = null;
                }
                if (this.tech_) {
                    this.tech_.dispose();
                    this.isPosterFromTech_ = false;
                    this.poster_ = '';
                }
                if (this.playerElIngest_) {
                    this.playerElIngest_ = null;
                }
                if (this.tag) {
                    this.tag = null;
                }
                _get(_getPrototypeOf(Player.prototype), 'dispose', this).call(this);
            }
        },
        {
            key: 'width',
            value: function width(value) {
                return this.dimension('width', value);
            }
        },
        {
            key: 'height',
            value: function height(value) {
                return this.dimension('height', value);
            }
        },
        {
            key: 'dimension',
            value: function dimension(_dimension, value) {
                var privDimension = _dimension + '_';
                if (value === undefined) {
                    return this[privDimension] || 0;
                }
                if (value === '') {
                    this[privDimension] = undefined;
                    return;
                }
                var parsedVal = parseFloat(value);
                if (isNaN(parsedVal)) {
                    log.error('Improper value "'.concat(value, '" supplied for for ').concat(_dimension));
                    return;
                }
                this[privDimension] = parsedVal;
            }
        },
        {
            key: 'aspectRatio',
            value: function aspectRatio(ratio) {
                if (ratio === undefined) {
                    return this.aspectRatio_;
                }
                if (!/^\d+:\d+$/.test(ratio)) {
                    throw new Error('Improper value supplied for aspect ratio. The format should be width:height, for example 16:9.');
                }
                this.aspectRatio_ = ratio;
            }
        },
        {
            key: 'loadTech_',
            value: function loadTech_(techName, source) {
                var _this2 = this;
                if (this.tech_) {
                    this.unloadTech_();
                }
                var titleTechName = toTitleCase(techName);
                var camelTechName = techName.charAt(0).toLowerCase() + techName.slice(1);
                this.techName_ = titleTechName;
                this.isReady_ = false;
                var autoplay = typeof this.autoplay() === 'string' ? false : this.autoplay();
                var techOptions = {
                    source: source,
                    autoplay: autoplay,
                    playerId: this.id(),
                    techId: ''.concat(this.id(), '_').concat(camelTechName, '_api'),
                    playsinline: this.options_.playsinline,
                    preload: this.options_.preload,
                    loop: this.options_.loop,
                    muted: this.options_.muted,
                    language: this.language(),
                    playerElIngest: this.playerElIngest_ || false,
                    enableSourceset: this.options_.enableSourceset,
                    el: this.el_
                };
                TRACK_TYPES.names.forEach(function (name) {
                    var props = TRACK_TYPES[name];
                    techOptions[props.getterName] = _this2[props.privateName];
                });
                assign(techOptions, this.options_[titleTechName]);
                assign(techOptions, this.options_[camelTechName]);
                assign(techOptions, this.options_[techName.toLowerCase()]);
                if (this.tag) {
                    techOptions.tag = this.tag;
                }
                if (source && source.src === this.cache_.src && this.cache_.currentTime > 0) {
                    techOptions.startTime = this.cache_.currentTime;
                }
                var TechClass = Tech.getTech(techName);
                if (!TechClass) {
                    throw new Error('No Tech named \''.concat(titleTechName, '\' exists! \'').concat(titleTechName, '\' should be registered using emav.registerTech()\''));
                }
                this.tech_ = new TechClass(techOptions);
                this.tech_.ready(Fn.bind(this, this.handleTechReady_), true);
                TECH_EVENTS_RETRIGGER.forEach(function (event) {
                    _this2.on(_this2.tech_, event, _this2['handleTech'.concat(toTitleCase(event), '_')]);
                });
                Object.keys(TECH_EVENTS_QUEUE).forEach(function (event) {
                    _this2.on(_this2.tech_, event, function (eventObj) {
                        console.log('~~~~~~~~~~~~~~~~~', event, eventObj);
                        if (_this2.tech_.playbackRate() === 0 && _this2.tech_.seeking()) {
                            _this2.queuedCallbacks_.push({
                                callback: _this2['handleTech'.concat(TECH_EVENTS_QUEUE[event], '_')].bind(_this2),
                                event: eventObj
                            });
                            return;
                        }
                        _this2['handleTech'.concat(TECH_EVENTS_QUEUE[event], '_')](eventObj);
                    });
                });
                this.on(this.tech_, 'loadstart', this.handleTechLoadStart_);
                this.on(this.tech_, 'sourceset', this.handleTechSourceset_);
                this.on(this.tech_, 'waiting', this.handleTechWaiting_);
                this.on(this.tech_, 'ended', this.handleTechEnded_);
                this.on(this.tech_, 'seeking', this.handleTechSeeking_);
                this.on(this.tech_, 'seeked', this.handleTechSeeked_);
                this.on(this.tech_, 'play', this.handleTechPlay_);
                this.on(this.tech_, 'firstplay', this.handleTechFirstPlay_);
                this.on(this.tech_, 'pause', this.handleTechPause_);
                this.on(this.tech_, 'durationchange', this.handleTechDurationChange_);
                this.on(this.tech_, 'error', this.handleTechError_);
                this.on(this.tech_, 'ratechange', this.handleTechRateChange_);
                console.log('loadTech_:', techName, source);
            }
        },
        {
            key: 'unloadTech_',
            value: function unloadTech_() {
                var _this3 = this;
                TRACK_TYPES.names.forEach(function (name) {
                    var props = TRACK_TYPES[name];
                    _this3[props.privateName] = _this3[props.getterName]();
                });
                this.isReady_ = false;
                this.tech_.dispose();
                this.tech_ = false;
            }
        },
        {
            key: 'tech',
            value: function tech(safety) {
                if (safety === undefined) {
                    log.warn(tsml(_templateObject()));
                }
                return this.tech_;
            }
        },
        {
            key: 'addTechControlsListeners_',
            value: function addTechControlsListeners_() {
                this.removeTechControlsListeners_();
                this.on(this.tech_, 'mouseup', this.handleTechClick_);
                this.on(this.tech_, 'dblclick', this.handleTechDoubleClick_);
                this.on(this.tech_, 'touchstart', this.handleTechTouchStart_);
                this.on(this.tech_, 'touchmove', this.handleTechTouchMove_);
                this.on(this.tech_, 'touchend', this.handleTechTouchEnd_);
                this.on(this.tech_, 'emavtap', this.handleTechTap_);
            }
        },
        {
            key: 'handleTechReady_',
            value: function handleTechReady_() {
                this.triggerReady();
                if (this.cache_.volume) {
                    this.techCall_('setVolume', this.cache_.volume);
                }
                this.handleTechDurationChange_();
            }
        },
        {
            key: 'handleTechLoadStart_',
            value: function handleTechLoadStart_() {
                this.error(null);
                this.handleTechDurationChange_();
                if (!this.paused()) {
                    this.trigger('firstplay');
                } else {
                    this.hasStarted(false);
                }
            }
        },
        {
            key: 'updateSourceCaches_',
            value: function updateSourceCaches_() {
                var srcObj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
                var src = srcObj;
                var type = '';
                if (typeof src !== 'string') {
                    src = srcObj.src;
                    type = srcObj.type;
                }
                this.cache_.source = this.cache_.source || {};
                this.cache_.sources = this.cache_.sources || [];
                if (src && !type) {
                    type = findMimetype(this, src);
                }
                this.cache_.source = mergeOptions({}, srcObj, {
                    src: src,
                    type: type
                });
                var matchingSources = this.cache_.sources.filter(function (s) {
                    return s.src && s.src === src;
                });
                var sourceElSources = [];
                var sourceEls = this.$$('source');
                var matchingSourceEls = [];
                for (var i = 0; i < sourceEls.length; i++) {
                    var sourceObj = Dom.getAttributes(sourceEls[i]);
                    sourceElSources.push(sourceObj);
                    if (sourceObj.src && sourceObj.src === src) {
                        matchingSourceEls.push(sourceObj.src);
                    }
                }
                if (matchingSourceEls.length && !matchingSources.length) {
                    this.cache_.sources = sourceElSources;
                } else if (!matchingSources.length) {
                    this.cache_.sources = [this.cache_.source];
                }
                this.cache_.src = src;
            }
        },
        {
            key: 'handleTechSourceset_',
            value: function handleTechSourceset_(event) {
                var _this4 = this;
                if (!this.changingSrc_) {
                    var updateSourceCaches = function updateSourceCaches(src) {
                        return _this4.updateSourceCaches_(src);
                    };
                    var playerSrc = this.currentSource().src;
                    var eventSrc = event.src;
                    if (playerSrc && !/^blob:/.test(playerSrc) && /^blob:/.test(eventSrc)) {
                        if (!this.lastSource_ || this.lastSource_.tech !== eventSrc && this.lastSource_.player !== playerSrc) {
                            updateSourceCaches = function updateSourceCaches() {
                            };
                        }
                    }
                    updateSourceCaches(eventSrc);
                    if (!event.src) {
                        var updateCache = function updateCache(e) {
                            if (e.type !== 'sourceset') {
                                var techSrc = _this4.techGet('currentSrc');
                                _this4.lastSource_.tech = techSrc;
                                _this4.updateSourceCaches_(techSrc);
                            }
                            _this4.tech_.off([
                                'sourceset',
                                'loadstart'
                            ], updateCache);
                        };
                        this.tech_.one([
                            'sourceset',
                            'loadstart'
                        ], updateCache);
                    }
                }
                this.lastSource_ = {
                    player: this.currentSource().src,
                    tech: event.src
                };
                this.trigger({
                    src: event.src,
                    type: 'sourceset'
                });
            }
        },
        {
            key: 'hasStarted',
            value: function hasStarted(request) {
                if (request === undefined) {
                    return this.hasStarted_;
                }
                if (request === this.hasStarted_) {
                    return;
                }
                this.hasStarted_ = request;
                if (this.hasStarted_) {
                    this.trigger('firstplay');
                }
            }
        },
        {
            key: 'handleTechPlay_',
            value: function handleTechPlay_() {
                this.hasStarted(true);
            }
        },
        {
            key: 'handleTechRateChange_',
            value: function handleTechRateChange_() {
                if (this.tech_.playbackRate() > 0 && this.cache_.lastPlaybackRate === 0) {
                    this.queuedCallbacks_.forEach(function (queued) {
                        return queued.callback(queued.event);
                    });
                    this.queuedCallbacks_ = [];
                }
                this.cache_.lastPlaybackRate = this.tech_.playbackRate();
            }
        },
        {
            key: 'handleTechWaiting_',
            value: function handleTechWaiting_() {
                var _this5 = this;
                var timeWhenWaiting = this.currentTime();
                var timeUpdateListener = function timeUpdateListener() {
                    if (timeWhenWaiting !== _this5.currentTime()) {
                        _this5.off('timeupdate', timeUpdateListener);
                    }
                };
                this.on('timeupdate', timeUpdateListener);
            }
        },
        {
            key: 'handleTechSeeking_',
            value: function handleTechSeeking_() {
            }
        },
        {
            key: 'handleTechSeeked_',
            value: function handleTechSeeked_() {
            }
        },
        {
            key: 'handleTechFirstPlay_',
            value: function handleTechFirstPlay_() {
                if (this.options_.starttime) {
                    log.warn('Passing the `starttime` option to the player will be deprecated in 6.0');
                    this.currentTime(this.options_.starttime);
                }
            }
        },
        {
            key: 'handleTechPause_',
            value: function handleTechPause_() {
            }
        },
        {
            key: 'handleTechEnded_',
            value: function handleTechEnded_() {
                if (this.options_.loop) {
                    this.currentTime(0);
                    this.play();
                } else if (!this.paused()) {
                    this.pause();
                }
            }
        },
        {
            key: 'handleTechDurationChange_',
            value: function handleTechDurationChange_() {
                this.duration(this.techGet_('duration'));
            }
        },
        {
            key: 'handleTechError_',
            value: function handleTechError_() {
                var error = this.tech_.error();
                this.error(error);
            }
        },
        {
            key: 'getCache',
            value: function getCache() {
                return this.cache_;
            }
        },
        {
            key: 'resetCache_',
            value: function resetCache_() {
                this.cache_ = {
                    currentTime: 0,
                    inactivityTimeout: this.options_.inactivityTimeout,
                    duration: NaN,
                    lastVolume: 1,
                    lastPlaybackRate: this.defaultPlaybackRate(),
                    media: null,
                    src: '',
                    source: {},
                    sources: [],
                    volume: 1
                };
            }
        },
        {
            key: 'techCall_',
            value: function techCall_(method, arg) {
                this.ready(function () {
                    try {
                        if (this.tech_) {
                            this.tech_[method](arg);
                        }
                    } catch (e) {
                        log(e);
                        throw e;
                    }
                }, true);
            }
        },
        {
            key: 'techGet_',
            value: function techGet_(method) {
                if (!this.tech_ || !this.tech_.isReady_) {
                    return;
                }
                try {
                    return this.tech_[method]();
                } catch (e) {
                    if (this.tech_[method] === undefined) {
                        log('emav.js: '.concat(method, ' method not defined for ').concat(this.techName_, ' playback technology.'), e);
                        throw e;
                    }
                    if (e.name === 'TypeError') {
                        log('emav.js: '.concat(method, ' unavailable on ').concat(this.techName_, ' playback technology element.'), e);
                        this.tech_.isReady_ = false;
                        throw e;
                    }
                    log(e);
                    throw e;
                }
            }
        },
        {
            key: 'play',
            value: function play() {
                var _this6 = this;
                var PromiseClass = this.options_.Promise || window.Promise;
                if (PromiseClass) {
                    return new PromiseClass(function (resolve) {
                        _this6.play_(resolve);
                    });
                }
                return this.play_();
            }
        },
        {
            key: 'play_',
            value: function play_() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : silencePromise;
                callback(this.techGet_('play'));
                return;
            }
        },
        {
            key: 'pause',
            value: function pause() {
                this.techCall_('pause');
            }
        },
        {
            key: 'paused',
            value: function paused() {
                return this.techGet_('paused') === false ? false : true;
            }
        },
        {
            key: 'played',
            value: function played() {
                return this.techGet_('played') || createTimeRange(0, 0);
            }
        },
        {
            key: 'currentTime',
            value: function currentTime(seconds) {
                if (typeof seconds !== 'undefined') {
                    if (seconds < 0) {
                        seconds = 0;
                    }
                    this.techCall_('setCurrentTime', seconds);
                    return;
                }
                this.cache_.currentTime = this.techGet_('currentTime') || 0;
                return this.cache_.currentTime;
            }
        },
        {
            key: 'duration',
            value: function duration(seconds) {
                if (seconds === undefined) {
                    return this.cache_.duration = this.techGet_('duration') || NaN;
                }
                seconds = parseFloat(seconds);
                if (seconds < 0) {
                    seconds = Infinity;
                }
                if (seconds !== this.cache_.duration) {
                    this.cache_.duration = seconds;
                    if (!isNaN(seconds)) {
                        this.trigger('durationchange');
                    }
                }
            }
        },
        {
            key: 'remainingTime',
            value: function remainingTime() {
                return this.duration() - this.currentTime();
            }
        },
        {
            key: 'remainingTimeDisplay',
            value: function remainingTimeDisplay() {
                return Math.floor(this.duration()) - Math.floor(this.currentTime());
            }
        },
        {
            key: 'buffered',
            value: function buffered() {
                var buffered = this.techGet_('buffered');
                if (!buffered || !buffered.length) {
                    buffered = createTimeRange(0, 0);
                }
                return buffered;
            }
        },
        {
            key: 'bufferedPercent',
            value: function bufferedPercent() {
                return _bufferedPercent(this.buffered(), this.duration());
            }
        },
        {
            key: 'bufferedEnd',
            value: function bufferedEnd() {
                var buffered = this.buffered();
                var duration = this.duration();
                var end = buffered.end(buffered.length - 1);
                if (end > duration) {
                    end = duration;
                }
                return end;
            }
        },
        {
            key: 'volume',
            value: function volume(percentAsDecimal) {
                var vol;
                if (percentAsDecimal !== undefined) {
                    vol = Math.max(0, Math.min(1, parseFloat(percentAsDecimal)));
                    this.cache_.volume = vol;
                    this.techCall_('setVolume', vol);
                    if (vol > 0) {
                        this.lastVolume_(vol);
                    }
                    return;
                }
                vol = parseFloat(this.techGet_('volume'));
                return isNaN(vol) ? 1 : vol;
            }
        },
        {
            key: 'muted',
            value: function muted(_muted) {
                if (_muted !== undefined) {
                    this.techCall_('setMuted', _muted);
                    return;
                }
                return this.techGet_('muted') || false;
            }
        },
        {
            key: 'canPlayType',
            value: function canPlayType(type) {
                var can;
                for (var i = 0, j = this.options_.techOrder; i < j.length; i++) {
                    var techName = j[i];
                    var tech = Tech.getTech(techName);
                    if (!tech) {
                        tech = Component.getComponent(techName);
                    }
                    if (!tech) {
                        log.error('The "'.concat(techName, '" tech is undefined. Skipped browser support check for that tech.'));
                        continue;
                    }
                    if (tech.isSupported()) {
                        can = tech.canPlayType(type);
                        if (can) {
                            return can;
                        }
                    }
                }
                return '';
            }
        },
        {
            key: 'selectSource',
            value: function selectSource(sources) {
                var _this7 = this;
                var techs = this.options_.techOrder.map(function (techName) {
                    return [
                        techName,
                        Tech.getTech(techName)
                    ];
                }).filter(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2), techName = _ref2[0], tech = _ref2[1];
                    if (tech) {
                        var isSupport = tech.isSupported();
                        console.log('selectSource:', isSupport, techName);
                        return isSupport;
                    }
                    log.error('The "'.concat(techName, '" tech is undefined. Skipped browser support check for that tech.'));
                    return false;
                });
                var findFirstPassingTechSourcePair = function findFirstPassingTechSourcePair(outerArray, innerArray, tester) {
                    var found;
                    outerArray.some(function (outerChoice) {
                        return innerArray.some(function (innerChoice) {
                            found = tester(outerChoice, innerChoice);
                            return found;
                        });
                    });
                    return found;
                };
                var foundSourceAndTech;
                var flip = function flip(fn) {
                    return function (a, b) {
                        return fn(b, a);
                    };
                };
                var finder = function finder(_ref3, source) {
                    var _ref4 = _slicedToArray(_ref3, 2), techName = _ref4[0], tech = _ref4[1];
                    if (tech.canPlaySource(source, _this7.options_[techName.toLowerCase()])) {
                        return {
                            source: source,
                            tech: techName
                        };
                    }
                };
                if (this.options_.sourceOrder) {
                    foundSourceAndTech = findFirstPassingTechSourcePair(sources, techs, flip(finder));
                } else {
                    foundSourceAndTech = findFirstPassingTechSourcePair(techs, sources, finder);
                }
                return foundSourceAndTech || false;
            }
        },
        {
            key: 'avInfo',
            value: function avInfo() {
                if (this.bizWrapper) {
                    return this.bizWrapper.avInfo;
                } else {
                    return null;
                }
            }
        },
        {
            key: 'src',
            value: function () {
                var _src = _asyncToGenerator(regeneratorRuntime.mark(function _callee(source) {
                    var avInfo;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                            switch (_context.prev = _context.next) {
                            case 0:
                                if (!(typeof source === 'undefined')) {
                                    _context.next = 2;
                                    break;
                                }
                                return _context.abrupt('return', this.cache_.src || '');
                            case 2:
                                if (!(this.options_ && (!this.options_.bizWrapper || this.options_.bizWrapper && this.options_.bizWrapper.enabled === true))) {
                                    _context.next = 9;
                                    break;
                                }
                                console.log('emav - bizWrapper:', this.options_, this.options_.bizWrapper);
                                _context.next = 6;
                                return this.bizWrapper.fixBizSource(source);
                            case 6:
                                avInfo = _context.sent;
                                if (avInfo) {
                                    this.trigger('gotavinfo', avInfo);
                                    if (avInfo.size > 0) {
                                        this.trigger('gotavsize', avInfo.size);
                                    }
                                }
                                source = avInfo.url;
                            case 9:
                                _context.next = 11;
                                return this.init(source);
                            case 11:
                            case 'end':
                                return _context.stop();
                            }
                        }
                    }, _callee, this);
                }));
                function src(_x) {
                    return _src.apply(this, arguments);
                }
                return src;
            }()
        },
        {
            key: 'init2',
            value: function () {
                var _init = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(source) {
                    var sources;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                        while (1) {
                            switch (_context2.prev = _context2.next) {
                            case 0:
                                sources = filterSource(source);
                                console.log('设置音视频地址:', source, sources);
                                if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
                                    this.techCall_('setSource', sources[0]);
                                }
                            case 3:
                            case 'end':
                                return _context2.stop();
                            }
                        }
                    }, _callee2, this);
                }));
                function init2(_x2) {
                    return _init.apply(this, arguments);
                }
                return init2;
            }()
        },
        {
            key: 'stopRefresh',
            value: function stopRefresh() {
                if (this.bizWrapper && this.bizWrapper.stopRefresh) {
                    this.bizWrapper.stopRefresh();
                }
            }
        },
        {
            key: 'init',
            value: function () {
                var _init2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(source) {
                    var _this8 = this;
                    var sources, sourceTech;
                    return regeneratorRuntime.wrap(function _callee3$(_context3) {
                        while (1) {
                            switch (_context3.prev = _context3.next) {
                            case 0:
                                sources = filterSource(source);
                                console.log('设置音视频地址:', source, sources);
                                if (!(!source || !sources.length)) {
                                    _context3.next = 4;
                                    break;
                                }
                                return _context3.abrupt('return');
                            case 4:
                                sourceTech = this.selectSource(sources);
                                console.log('init [1]:', sourceTech.tech, sourceTech.source, this.techName_);
                                if (sourceTech) {
                                    _context3.next = 8;
                                    break;
                                }
                                return _context3.abrupt('return', true);
                            case 8:
                                console.log('init [1.5]:', sourceTech.tech, sourceTech.source, this.techName_);
                                if (titleCaseEquals(sourceTech.tech, this.techName_)) {
                                    _context3.next = 15;
                                    break;
                                }
                                console.log('init [1.6]:', sourceTech.tech, sourceTech.source, this.techName_);
                                this.changingSrc_ = true;
                                this.loadTech_(sourceTech.tech, sourceTech.source);
                                this.tech_.ready(function () {
                                    console.log('init [1.7]:', sourceTech.tech, sourceTech.source, _this8.techName_);
                                    _this8.changingSrc_ = false;
                                });
                                return _context3.abrupt('return', false);
                            case 15:
                                this.ready(function () {
                                    console.log('init [2.0]:', sourceTech.tech, sourceTech.source, this.techName_);
                                    if (this.tech_.constructor.prototype.hasOwnProperty('setSource')) {
                                        this.techCall_('setSource', sourceTech.source);
                                    } else {
                                        this.techCall_('src', sourceTech.source.src);
                                    }
                                    this.changingSrc_ = false;
                                }, true);
                                console.log('init [2]:', sourceTech.tech, sourceTech.source, this.techName_);
                            case 17:
                            case 'end':
                                return _context3.stop();
                            }
                        }
                    }, _callee3, this);
                }));
                function init(_x3) {
                    return _init2.apply(this, arguments);
                }
                return init;
            }()
        },
        {
            key: 'load',
            value: function load() {
                this.techCall_('load');
            }
        },
        {
            key: 'reset',
            value: function reset() {
                this.resetCache_();
                this.loadTech_(this.options_.techOrder[0], null);
                this.techCall_('reset');
            }
        },
        {
            key: 'resetPlaybackRate_',
            value: function resetPlaybackRate_() {
                this.playbackRate(this.defaultPlaybackRate());
                this.handleTechRateChange_();
            }
        },
        {
            key: 'resetVolume',
            value: function resetVolume() {
                this.volume(1);
                this.trigger('volumechange');
            }
        },
        {
            key: 'currentSources',
            value: function currentSources() {
                var source = this.currentSource();
                var sources = [];
                if (Object.keys(source).length !== 0) {
                    sources.push(source);
                }
                return this.cache_.sources || sources;
            }
        },
        {
            key: 'currentSource',
            value: function currentSource() {
                return this.cache_.source || {};
            }
        },
        {
            key: 'currentSrc',
            value: function currentSrc() {
                return this.currentSource() && this.currentSource().src || '';
            }
        },
        {
            key: 'currentType',
            value: function currentType() {
                return this.currentSource() && this.currentSource().type || '';
            }
        },
        {
            key: 'preload',
            value: function preload(value) {
                if (value !== undefined) {
                    this.techCall_('setPreload', value);
                    this.options_.preload = value;
                    return;
                }
                return this.techGet_('preload');
            }
        },
        {
            key: 'autoplay',
            value: function autoplay(value) {
                if (value === undefined) {
                    return this.options_.autoplay || false;
                }
                var techAutoplay;
                if (typeof value === 'string' && /(any|play|muted)/.test(value)) {
                    this.options_.autoplay = value;
                    this.manualAutoplay_(value);
                    techAutoplay = false;
                } else if (!value) {
                    this.options_.autoplay = false;
                } else {
                    this.options_.autoplay = true;
                }
                techAutoplay = techAutoplay || this.options_.autoplay;
                if (this.tech_) {
                    this.techCall_('setAutoplay', techAutoplay);
                }
            }
        },
        {
            key: 'playsinline',
            value: function playsinline(value) {
                if (value !== undefined) {
                    this.techCall_('setPlaysinline', value);
                    this.options_.playsinline = value;
                    return this;
                }
                return this.techGet_('playsinline');
            }
        },
        {
            key: 'loop',
            value: function loop(value) {
                if (value !== undefined) {
                    this.techCall_('setLoop', value);
                    this.options_.loop = value;
                    return;
                }
                return this.techGet_('loop');
            }
        },
        {
            key: 'error',
            value: function error(err) {
                return;
            }
        },
        {
            key: 'playbackRate',
            value: function playbackRate(rate) {
                if (rate !== undefined) {
                    this.techCall_('setPlaybackRate', rate);
                    return;
                }
                if (this.tech_ && this.tech_.featuresPlaybackRate) {
                    return this.cache_.lastPlaybackRate || this.techGet_('playbackRate');
                }
                return 1;
            }
        },
        {
            key: 'defaultPlaybackRate',
            value: function defaultPlaybackRate(rate) {
                if (rate !== undefined) {
                    return this.techCall_('setDefaultPlaybackRate', rate);
                }
                if (this.tech_ && this.tech_.featuresPlaybackRate) {
                    return this.techGet_('defaultPlaybackRate');
                }
                return 1;
            }
        },
        {
            key: 'isAudio',
            value: function isAudio(bool) {
                if (bool !== undefined) {
                    this.isAudio_ = !!bool;
                    return;
                }
                return !!this.isAudio_;
            }
        },
        {
            key: 'getVideoPlaybackQuality',
            value: function getVideoPlaybackQuality() {
                return this.techGet_('getVideoPlaybackQuality');
            }
        },
        {
            key: 'videoWidth',
            value: function videoWidth() {
                return this.tech_ && this.tech_.videoWidth && this.tech_.videoWidth() || 0;
            }
        },
        {
            key: 'videoHeight',
            value: function videoHeight() {
                return this.tech_ && this.tech_.videoHeight && this.tech_.videoHeight() || 0;
            }
        },
        {
            key: 'language',
            value: function language(code) {
                if (code === undefined) {
                    return this.language_;
                }
                this.language_ = String(code).toLowerCase();
            }
        },
        {
            key: 'languages',
            value: function languages() {
                return mergeOptions(Player.prototype.options_.languages, this.languages_);
            }
        },
        {
            key: 'loadMedia',
            value: function loadMedia(media, ready) {
                if (!media || _typeof(media) !== 'object') {
                    return;
                }
                this.reset();
                this.cache_.media = mergeOptions(media);
                var src = this.cache_.media.src;
                if (src) {
                    this.src(src);
                }
                this.ready(ready);
            }
        },
        {
            key: 'getMedia',
            value: function getMedia() {
                if (!this.cache_.media) {
                    var src = this.currentSources();
                    var media = { src: src };
                    return media;
                }
                return mergeOptions(this.cache_.media);
            }
        },
        {
            key: 'lastVolume_',
            value: function lastVolume_(percentAsDecimal) {
                if (percentAsDecimal !== undefined && percentAsDecimal !== 0) {
                    this.cache_.lastVolume = percentAsDecimal;
                    return;
                }
                return this.cache_.lastVolume;
            }
        }
    ], [{
            key: 'getTagSettings',
            value: function getTagSettings(tag) {
                var baseOptions = {
                    sources: [],
                    tracks: []
                };
                var tagOptions = Dom.getAttributes(tag);
                assign(baseOptions, tagOptions);
                if (tag.hasChildNodes()) {
                    var children = tag.childNodes;
                    for (var i = 0, j = children.length; i < j; i++) {
                        var child = children[i];
                        var childName = child.nodeName.toLowerCase();
                        if (childName === 'source') {
                            baseOptions.sources.push(Dom.getAttributes(child));
                        }
                    }
                }
                return baseOptions;
            }
        }]);
    return Player;
}(Component);
TRACK_TYPES.names.forEach(function (name) {
    var props = TRACK_TYPES[name];
    Player.prototype[props.getterName] = function () {
        if (this.tech_) {
            return this.tech_[props.getterName]();
        }
        this[props.privateName] = this[props.privateName] || new props.ListClass();
        return this[props.privateName];
    };
});
Player.players = {};
var navigator = window.navigator;
Player.prototype.options_ = {
    techOrder: Tech.defaultTechOrder_,
    html5: {},
    flash: {},
    playbackRates: [],
    liveui: false,
    children: ['mediaLoader'],
    language: navigator && (navigator.languages && navigator.languages[0] || navigator.userLanguage || navigator.language) || 'en',
    languages: {},
    notSupportedMessage: 'No compatible source was found for this media.'
};
[
    'ended',
    'seeking',
    'seekable',
    'networkState',
    'readyState'
].forEach(function (fn) {
    Player.prototype[fn] = function () {
        return this.techGet_(fn);
    };
});
TECH_EVENTS_RETRIGGER.forEach(function (event) {
    Player.prototype['handleTech'.concat(toTitleCase(event), '_')] = function () {
    };
});
export default Player;